import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Modal from '../modal/Modal'
import styles from './index.module.scss'
import Autocomplete from '../autoComplete/AutoComplete'
import { Spinner } from '../../pages/shared/Spinner'
import ClientDetailsLoader from './ClientDetailsLoader'
import PreviewDocument from './PreviewDocument'
import usePreviewClient from './usePreviewClient'

const PREVIEW_CLIENT_AUTOCOMPLETE_ID = 'autocomplete_agreement_preview_client_id'

export default function AgreementPreviewModal ({
  show,
  onHide,
  content,
  clients,
  isClientsFetching
}) {
  const {
    clientId,
    companyName,
    requestId,
    previewContent,
    isClientFetching,
    selectedClient,
    clearClient,
    handleClientSelect,
    handleClientLoaded,
    handleClientLoadingChange
  } = usePreviewClient({
    show,
    content,
    clients
  })

  return (
    <Modal
      isOpen={show}
      closeModal={onHide}
      className={styles.modal}>
      <div className={styles.inner}>
        <header className={styles.header}>
          <h2 className={styles.title}>
            Template Preview
          </h2>
          <button
            type='button'
            className={cn(styles.closeBtn, 'dis-btn dis-btn-no-shadow')}
            onClick={onHide}>
            CLOSE
            <i className={cn(styles.closeIcon, 'material-icons')}>close</i>
          </button>
        </header>

        <div className={styles.body}>
          {clientId && (
            <ClientDetailsLoader
              clientId={clientId}
              content={content}
              companyName={companyName}
              requestId={requestId}
              onClientLoaded={handleClientLoaded}
              onLoadingChange={handleClientLoadingChange}
            />
          )}
          <div
            className={styles.accountSelection}>
            <Spinner
              isFetching={isClientsFetching}>
              <div className='form-group'>
                <label htmlFor={PREVIEW_CLIENT_AUTOCOMPLETE_ID} className='control-label'>Account Name</label>
                <Autocomplete
                  name='client_id'
                  data={clients || []}
                  value={selectedClient || ''}
                  id={PREVIEW_CLIENT_AUTOCOMPLETE_ID}
                  onSelect={handleClientSelect}
                  onClear={clearClient}
                />
              </div>
            </Spinner>
          </div>

          <PreviewDocument
            previewContent={previewContent}
            isClientFetching={isClientFetching}
            clientId={clientId}
          />
        </div>
      </div>
    </Modal>
  )
}

AgreementPreviewModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  content: PropTypes.string,
  clients: PropTypes.array,
  isClientsFetching: PropTypes.bool
}

AgreementPreviewModal.defaultProps = {
  content: '',
  clients: [],
  isClientsFetching: false
}
